import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useAssistant } from 'app/domains/assistant';
import { Message } from 'app/domains/common-ui/Chat';
import { ChatMessageStatus } from 'shared/domains/apollo/generated/types';
import { CustomTable } from './CustomTable';
import { useCopyRichText } from './useCopyRichText';
import { useFeedback } from './useFeedback';
export function AssistantMessage(props) {
    const { message, status } = props;
    const { isLatestMessage, markdown, feedbackScore } = message;
    const { isStreaming, fuzzySearchTextNodes } = useAssistant();
    const { copyToClipboard, isCopied } = useCopyRichText();
    const { likeAction, dislikeAction, feedbackDialog } = useFeedback({
        commentId: message.id,
        feedbackScore,
    });
    const loading = isLatestMessage && !markdown;
    const streaming = isLatestMessage && isStreaming;
    const handleCopy = () => {
        if (!message.markdown || isCopied) {
            return;
        }
        copyToClipboard(message.markdown);
    };
    const copyAction = {
        icon: <Falcon icon="copy"/>,
        tooltip: t({
            comment: 'document assistant - assistant reply action - copy message',
            message: 'Copy message',
        }),
        disabled: !message.markdown,
        onClick: handleCopy,
    };
    const copiedAction = {
        icon: <Falcon icon="check"/>,
        tooltip: t({
            comment: 'document assistant - assistant reply action - message copied',
            message: 'Message copied',
        }),
        disabled: false,
        onClick: handleCopy,
    };
    const actions = [isCopied ? copiedAction : copyAction, dislikeAction, likeAction];
    const getFeedbackProps = (score) => {
        if (score === null || score === undefined || score === 0) {
            return undefined;
        }
        if (score > 0) {
            return {
                icon: <Falcon icon="thumbs-up"/>,
                tooltip: t({
                    comment: 'Document assistant - assistant reply positive feedback - aria label (screen reader)',
                    message: 'You thought this answer was helpful',
                }),
            };
        }
        return {
            icon: <Falcon icon="thumbs-down"/>,
            tooltip: t({
                comment: 'Document assistant - assistant reply negative feedback - aria label (screen reader)',
                message: 'You thought this answer was unhelpful',
            }),
        };
    };
    return (<Fragment>
      <Message fullWidth align="left" appearance="secondary" avatar={{ icon: <Falcon icon="sparkles"/>, appearance: 'indigo' }} message={message} loading={loading} streaming={streaming} showActionsDefault={isLatestMessage} actions={status === ChatMessageStatus.Resolved ? actions : []} onFootnoteClick={fuzzySearchTextNodes} components={[{ tagName: 'table', component: CustomTable }]} badge={getFeedbackProps(feedbackScore)}/>
      {feedbackDialog}
    </Fragment>);
}
